import React from 'react';
import { Text } from 'src/components/Text/Text';
import { EmailSubscriber } from 'src/components/EmailSubscriber/EmailSubscriber';
import { RibbonTag } from 'src/components/RibbonTag';
import { Image } from 'src/components/Image/Image';
import styles from './NewsLetters.module.scss';
import useDictionary from 'src/lib/hooks/useDictionary';

const NewsLetters = () => {
	const dictionary = useDictionary();
	return (
		<section className={styles.wrapper}>
			<Image url={'/shared/images/newletter-background.jpg'} className={styles.background} />
			<div className={styles.inner}>
				<Text className={styles.textWrapper}>
					<Text className={styles.updatesText}>{dictionary("Get updates on the")} </Text>
					<RibbonTag direction={'left'} backgroundColor={'#454582'} dotColor={'#0060CE'}>
						<Text className={styles.updatesText}>{dictionary("hottest deals")}</Text>
					</RibbonTag>
				</Text>
				<EmailSubscriber />
			</div>
		</section>
	);
};

export default NewsLetters;
